<ng-container *ngIf="!!text">
    <div [innerHTML]="text | safeHtml" [class]="class" *ngIf="block"></div>
    <span [innerHTML]="text | safeHtml" [class]="class" *ngIf="!block"></span>
</ng-container>